// components
import { ExButton } from '@commons/EXComponentsLibrary';
// interface
import { IMessagesDragDropUploader } from './MessagesDragDropUploader.interface';
// style
import style from './MessagesDragDropUploader.module.css';

const MessagesDragDropUploader = ({ icon, text, subtitle, flag }: IMessagesDragDropUploader) => {
    return (
        <div className={style['container']}>
            <div className={style['icon-or-image-cotainer']}>{icon}</div>

            <div className={style['container-text-message']}>
                <p className={style['text-messages']}>{text}</p>
                {!!flag && (
                    <ExButton className={style['button-upload-file']} appearance="alternative" size="lg">
                        <span className="button__upload-file-2">Subir archivo</span>
                    </ExButton>
                )}
                {subtitle && <p className={style['subtitle-text-message']}>{subtitle}</p>}
            </div>
        </div>
    );
};

export default MessagesDragDropUploader;
